import { Link } from "react-router-dom";
import { Cpu, Scan, Camera, Aperture, ArrowUpRight } from "lucide-react";
import "./VirtualProductions.css";


const POINTS = [
    {
        icon: Camera,
        title: "CAMERA TRACKING",
        desc: "Rapid deployment with markerless tracking for handheld, jib, crane, and broadcast camera systems.",
    },
    {
        icon: Scan,
        title: "MOTION CAPTURE & LiDAR",
        desc: "High-precision motion capture and LiDAR scanning for virtual production, broadcast, film, and live experiences.",
    },
    {
        icon: Cpu,
        title: "INDIGENOUSLY ENGINEERED",
        desc: "Designed and engineered in India by a multidisciplinary team of embedded engineers, AI researchers, and creative technologists.",
    },
    {
        icon: Aperture,
        title: "REAL-TIME PHOTOREALISM",
        desc: "Photorealistic virtual environments powered by Unreal Engine for seamless real-time production.",
    },
];


const STUDIO =

    "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjB2aXJ0dWFsJTIwcHJvZHVjdGlvbiUyMHN0dWRpb3xlbnwwfHx8fDE3ODIyMDcyODN8MA&ixlib=rb-4.1.0&q=85";



export const VirtualProductions = () => {

    return (
        <section
            id="virtual-productions"
            data-testid="virtual-productions-section"
            className="vp-section py-5 py-md-10 border-top"
        >
            <div className="container-db">
                <div className="row g-5 align-items-start">

                    <div className="col-12 col-lg-6">
                        <div className="position-relative vp-img-box overflow-hidden">
                            <div
                                className="absolute-img bg-cover bg-center"
                                style={{ backgroundImage: `url(${STUDIO})` }}
                            />
                            <div className="vp-overlay" />

                            <div className="font-mono-tech defence-label-top fs-5 fw-bold">
                                INTELLITRACK - Camera Tracking
                            </div>


                        </div>
                    </div>

                    <div className="col-12 col-lg-6 d-flex flex-column gap-4">
                        <div>
                            <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                                ⟶ Virtual Productions & Innovation
                            </div>
                            <h2 className="font-heading section-heading">
                                Built in India
                                <br />
                                Trusted on Set
                            </h2>
                        </div>
                        <p className="text-muted-custom leading-relaxed m-0">
                            Our Virtual Production solutions integrate seamlessly with existing studio environments, enabling real-time photorealistic rendering through patented camera tracking, precision engineering, and advanced virtual production technologies.<br></br>
                            Powered by IntelliTrack™ - Our patented markerless camera tracking technology.

                        </p>

                        <div className="row g-4 my-2">
                            {POINTS.map((p) => {
                                const Icon = p.icon;
                                return (
                                    <div key={p.title} className="col-12 col-sm-6">
                                        <div className="d-flex gap-3">
                                            <Icon size={20} className="text-primary-custom flex-shrink-0 mt-1" />
                                            <div>
                                                <h4 className="font-heading vp-point-title">
                                                    {p.title}
                                                </h4>
                                                <p className="vp-point-desc m-0">
                                                    {p.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <Link
                            to="/projects"
                            data-testid="vp-projects-cta"
                            className="immersive-link font-mono-tech text-decoration-none align-self-start"
                        >
                            See it in production <ArrowUpRight size={16} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default VirtualProductions;
